import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from './services/user.service';
import { UserInformation } from './model/user-information.model';

/**
 * Decides where the root path lands. A non-admin tied to exactly one initiative
 * has nothing to choose from, so that initiative is opened straight away instead
 * of showing a single-row list. Admins always get the overview, since they work
 * across every initiative.
 */
export const homeRedirectGuard: CanActivateFn = (): Observable<UrlTree> => {
  const userService = inject(UserService);
  const router = inject(Router);
  return userService.getUserInformation().pipe(
    map((userInformation: UserInformation): UrlTree => {
      const organizationId: string = userInformation.organizationList[0]?.id ?? '';
      if (!userInformation.isAdmin && userInformation.organizationList.length === 1 && organizationId !== '') {
        return router.createUrlTree(['/create-edit-organization', organizationId]);
      }
      return router.createUrlTree(['/organization-list']);
    }),
    catchError(() => of(router.createUrlTree(['/organization-list']))),
  );
};
